// extracted by mini-css-extract-plugin
module.exports = {"leaf":"Leaf_leaf__1RQAY","inner":"Leaf_inner__21nuT","image":"Leaf_image__3E-Ku","title":"Leaf_title__2lUYg","tag":"Leaf_tag__3JVf9"};